import classNames from "classnames";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../styles/ToolsContainer.module.scss";
const ToolsContainer = ({ title }) => {
  const location = useLocation().pathname;
  const toolsList1 = [
    {
      id: 1,
      head: "How much will it cost to take out a bridging loan?",
      subHead: "You’re ready for your new project, so what will it cost?",
      btnText: "Total Costs",
    },
    {
      id: 2,
      head: "How much will it cost settle the bridging loan early?",
      subHead:
        "You’re ahead of the game and finshed your project early... so what’s the costs?",
      btnText: "Exiting Early",
    },
    {
      id: 3,
      head: "How much will it cost if I default?",
      subHead:
        "If your initial period has ended or is about to, find out the cost of doing nothing.",
      btnText: "Defaulting Cost",
    },
  ];
  const toolsList2 = [
    {
      id: 1,
      head: "Bridging Loan Calculator ",
      subHead:
        "A simple tool to help you see clearly how much the loan will cost. Our easy to use Bridging Loan calculator gives instant detailed quotes showing interest payable, charges and other costs associated with taking out a Bridging Loan.",
      btnText: "Bridging Cost Calc",
    },
    {
      id: 2,
      head: "Re-Bridging compared",
      subHead:
        "If your initial period has ended or is about to, find out the cost of doing nothing, and more importantly how much you could save if you act quickly and apply now. It’s free and we take the fuss out of it. ",
      btnText: "Re-Bridging Cost Calc",
    },
    {
      id: 3,
      head: "Development Finance Calculator",
      subHead:
        "Want to know the interest charges, facility, exit, valuation, QS, lenders legal fees. As well as, VAT refunds, profit before finance, profit after finance costs, total finance costs, total project cost, development profit and return on cost calculations",
      btnText: "Development Loan Calc",
    },
  ];
  const toolsList3 = [
    {
      id: 1,
      head: "How much will it cost to move you Bridging loan to a new lender? ",
      subHead:
        "If your initial period has ended or is about to, find out the cost of doing nothing.",
      btnText: "Re-Bridging Cost",
    },
    {
      id: 2,
      head: "How much will it cost to do nothing?",
      subHead: "Want to see what kind of nightmare we can save you from.",
      btnText: "Default Calaculator",
    },
    {
      id: 3,
      head: "Comparision Calculator",
      subHead:
        "Compare  the cost of moving to a new lender VS defaulting with your existing lender.",
      btnText: "Comparision Calculator",
    },
  ];
  const toolsList4 = [
    {
      id: 1,
      head: "Calculate the LTC and LTGDV",
      subHead:
        "Let us help you with this basic calculator to walk you through how to work out the Loan to Costs (LTC) and the Loan to Gross Development Value.",
      btnText: "LTC & LTGDV",
    },
    {
      id: 2,
      head: "Development Finance Calculator",
      subHead:
        "Looking to know how much it will all cost. Here is a calculator to help you work out the cost of the entire project",
      btnText: "Development Finance Calculator",
    },
    {
      id: 3,
      head: "How much will it cost to move you to a new Development finance lender?",
      subHead:
        "If your initial period has ended or is about to, find out the cost of doing nothing and how much to move the funding, creating more time",
      btnText: "Re-Development Finance Calculator",
    },
  ];
  const toolsList5 = [
    {
      id: 1,
      head: "A practical guide to your rights",
      subHead:
        "All you need to know, to arm yourself against lenders who wish to repossess your property",
      btnText: "Your Rights",
    },
    {
      id: 2,
      head: "How do i stop a repossession?",
      subHead:
        "Here we share a step by step guide on what to do when you are faced with this difficult situation.",
      btnText: "Stop Repo Guide",
    },
    {
      id: 3,
      head: "Repo Calculator",
      subHead:
        "Ever wondered ho wmuch money you will save or loose dependant on your actions. Essentially the calculator will breakdown the costs of a repo vs re-bridge.",
      btnText: "Repo Calculator",
    },
  ];
  const finalToolsList =
    title === "Bridging Loans"
      ? toolsList1
      : title === "Re-Bridging Loans"
      ? toolsList3
      : title === "home"
      ? toolsList2
      : title === "Development Finance"
      ? toolsList4
      : title === "Stop Repossessions"
      ? toolsList5
      : title === "Resources"
      ? toolsList3
      : " ";
  return (
    <div className={styles.toolsContainer}>
      <div className={styles.top}>
        <p className={styles.header}>Tools and calculators</p>
        <p className={styles.subHeader}>
          Practical gadgets to help keep things simple
        </p>
      </div>
      <div className={styles.middle}>
        {finalToolsList.map((item) => {
          return (
            <div
              className={classNames(
                styles.tool,
                location === "/rebridgingloans"
                  ? styles.reBridging
                  : location === "/stoprepossessions"
                  ? styles.sRepo
                  : location === "/developmentfinance"
                  ? styles.dFinance
                  : location === "/bridgingloans"
                  ? styles.bLoans
                  : location === "/" &&
                    finalToolsList === toolsList2 &&
                    item.id === 1
                  ? styles.home1
                  : location === "/" &&
                    finalToolsList === toolsList2 &&
                    item.id === 2
                  ? styles.home2
                  : location === "/" &&
                    finalToolsList === toolsList2 &&
                    item.id === 3
                  ? styles.home3
                  : ""
              )}
            >
              <p
                className={classNames(
                  styles.head,
                  location === "/rebridgingloans"
                    ? styles.reBridging
                    : location === "/stoprepossessions"
                    ? styles.sRepo
                    : location === "/developmentfinance"
                    ? styles.dFinance
                    : location === "/bridgingloans"
                    ? styles.bLoans
                    : // : location === "/"
                    // ? styles.home
                    location === "/" &&
                      finalToolsList === toolsList2 &&
                      item.id === 1
                    ? styles.home1
                    : location === "/" &&
                      finalToolsList === toolsList2 &&
                      item.id === 2
                    ? styles.home2
                    : location === "/" &&
                      finalToolsList === toolsList2 &&
                      item.id === 3
                    ? styles.home3
                    : ""
                )}
              >
                {item.head}
              </p>
              <p className={styles.subHead}>{item.subHead}</p>
              <Link
                to="/calculator"
                className={classNames(
                  styles.link,
                  location === "/rebridgingloans"
                    ? styles.reBridging
                    : location === "/stoprepossessions"
                    ? styles.sRepo
                    : location === "/developmentfinance"
                    ? styles.dFinance
                    : location === "/bridgingloans"
                    ? styles.bLoans
                    : location === "/" &&
                      finalToolsList === toolsList2 &&
                      item.id === 1
                    ? styles.home1
                    : location === "/" &&
                      finalToolsList === toolsList2 &&
                      item.id === 2
                    ? styles.home2
                    : location === "/" &&
                      finalToolsList === toolsList2 &&
                      item.id === 3
                    ? styles.home3
                    : ""
                )}
              >
                {item.btnText}
              </Link>
            </div>
          );
        })}
      </div>
      <div className={styles.bottom}>
        <Link
          to="/calculator"
          className={classNames(
            styles.allToolsLink,
            location === "/rebridgingloans"
              ? styles.reBridging
              : location === "/stoprepossessions"
              ? styles.sRepo
              : location === "/developmentfinance"
              ? styles.dFinance
              : location === "/bridgingloans"
              ? styles.bLoans
              : location === "/"
              ? styles.home
              : ""
          )}
        >
          See all Calculator Tools
        </Link>
      </div>
    </div>
  );
};

export default ToolsContainer;
